import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getOtherOptionsFromWindow } from "../../../utils";
import { getUserDecision } from "../../getUserDecision";
/**
 * Has the user already consent to the latest revision settings?
 */

var preDecisionGatewayUserConsent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var decision, revision, _getOtherOptionsFromW, revisionHash;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            decision = getUserDecision();

            if (!(decision === false)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            revision = decision.revision;
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), revisionHash = _getOtherOptionsFromW.revisionHash;
            return _context.abrupt("return", revisionHash === revision ? "consent" : false);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayUserConsent() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayUserConsent };